/* eslint-disable no-param-reassign */
import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'


export default {
  state: {
    count: 0,
    socket: null,
    isReady: false
  },
  mutations: {
    [MUTATION_TYPE.setNewConnection]: (state) => {
      // console.log('socket trying connect..')
      state.socket = new WebSocket('ws://local.gazprom-classes.etu.ru:70/api/ws/')

      state.socket.onmessage = (e) => {
        const response = JSON.parse(e.data)
        if (response.action && response.action === 'init') {
          // console.log('server socket is ready')
          state.isReady = true
        }
      }

      state.socket.onopen = () => {
        // console.log('client socket is ready')
      }

      state.socket.onclose = () => {
        state.socket = null
        state.isReady = false
        // console.log('disconnected')
      }
    },
    [MUTATION_TYPE.removeConnection]: (state) => {
      if (state.socket !== null) {
        state.socket.close()
        // console.log('connection has been removed')
      } else {
        // console.log('connection is already removed')
      }
    },
    [MUTATION_TYPE.setOnMessage]: (state, callback) => {
      // state.socket.onmessage = undefined
      state.socket.onmessage = callback
    }
  },
  actions: {
    [ACTION_TYPE.sendMessage]: ({ state }, message) => {
      const wsSend = function waitForSocketConnection(data) {
        setTimeout(
          () => {
            if (state.isReady === true && state.socket.readyState === WebSocket.OPEN) {
              state.socket.send(JSON.stringify(data))
            } else {
              waitForSocketConnection(data)
            }
          }, 10,
        )
      }

      wsSend(message)
    }
  },
  getters: {
    [GETTER_TYPE.getSocket]: (state) => state.socket,
    [GETTER_TYPE.isSocketReady]: (state) => state.isReady
  }
}
